export default __webpack_public_path__ + "static/media/stylator.a4c8b28d.png";